import React from 'react';
import { FaFile, FaFilePdf, FaFileImage, FaFileExcel, FaFileWord } from 'react-icons/fa';
import { buildFileUrl, formatFileSize, getFileMeta, truncateFileName } from '../../utils/chatHelpers';

const iconMap = {
  pdf: FaFilePdf,
  image: FaFileImage,
  sheet: FaFileExcel,
  doc: FaFileWord,
  file: FaFile,
};

const ChatFileBubble = ({ file, isOwn, apiBaseUrl, className = '' }) => {
  const meta = getFileMeta(file.originalName);
  const Icon = iconMap[meta.type] || FaFile;
  const href = buildFileUrl(apiBaseUrl, file.fileUrl);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-3 p-3 rounded-xl transition-all min-w-[200px] max-w-[280px] ${
        isOwn
          ? 'bg-white/15 hover:bg-white/25 text-white'
          : 'bg-gray-100 dark:bg-neutral-800 hover:bg-gray-200 dark:hover:bg-neutral-700 text-gray-900 dark:text-gray-100'
      } ${className}`}
    >
      <div className={`w-11 h-11 rounded-lg flex items-center justify-center shrink-0 ${isOwn ? 'bg-white/20' : meta.bg}`}>
        <Icon className={`w-5 h-5 ${isOwn ? 'text-white' : meta.color}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{truncateFileName(file.originalName)}</p>
        <p className={`text-[11px] mt-0.5 ${isOwn ? 'text-white/70' : 'text-gray-500 dark:text-gray-400'}`}>
          {meta.label}{file.size ? ` · ${formatFileSize(file.size)}` : ''}
        </p>
      </div>
    </a>
  );
};

export default ChatFileBubble;
